<template>
    <div class="row mt-3">
        <div v-if="error!=''" class="col-12 alert alert-danger" role="alert">
            {{ error }}
        </div>
        <item-cart class="col-12"
            :mini="false"
            :summary="true">
        </item-cart>
        <div class="col-12">
            <table>
                <tr>
                    <td>{{ $t('order.customer') }}: </td>
                    <td>{{ address.title }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.vat') }}: </td>
                    <td>{{ address.vat }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.address') }}: </td>
                    <td>{{ address.address }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.contact_person') }}: </td>
                    <td>{{ address.contact_person }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.email') }}: </td>
                    <td>{{ address.email }}</td>
                </tr>
                <tr>
                    <td>{{ $t('order.telephone') }}: </td>
                    <td>{{ address.telephone }}</td>
                </tr>
            </table>
        </div>
        <!--<div class="col-12 my-3">
            <label for="note">Notes</label>
            <textarea class="form-control" name="note" v-model="note"></textarea>
        </div>-->
        <div class="col-12">
            <button class="btn btn-danger" @click="lastStep">Go Back</button>
            <button type="submit" class="btn btn-danger" @click="finishOrder">Send order!</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: '',
            note: '',
        }
    },
    props: {
        address: Object,
    },
    methods: {
        finishOrder: function(loc){
            axios.post('/api/order', {
                address: this.address,
                items: this.$store.getters.cart,
                note: this.note
            }).then(response => {
                this.$store.dispatch('emptyCart');
                this.$store.dispatch('setOrderNum', response.data.order_number);
                this.nextStep();
            }).catch(error => {
                $('#order-error-modal').modal('show');
            });
        },
        lastStep: function(){
            this.$emit('step', 2);
        },
        nextStep: function(){
            this.$emit('step', 4);
        },
    },
}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';
</style>

